import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../core/useAuth';

export const KeycloakLogin = () => {
  const { login, isAuthenticated, isLoading, error } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const loginStarted = useRef(false);

  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo ||
    '/dashboard/hosting';

  /*
	        Keep login only in useEffect.
		      Add a guard to prevent duplicate calls.
		          */
  useEffect(() => {
    /*
					auto-login only once
					       */
    /*
						   	  Without loginStarted,
							  	  React Strict Mode would trigger double redirects.
								  	 */
    /* not past an error — it must stay readable, the button retries */
    if (!isLoading && !isAuthenticated && !error && !loginStarted.current) {
      loginStarted.current = true;
      login({ state: { returnTo } });
    }
  }, [isLoading, isAuthenticated, error, login, returnTo]);

  if (isLoading) {
    return <div>Lade Login...</div>;
  }

  return (
    <div>
      <p>Login</p>
      <p>Weiterleitung an Identity Provider zur Authentifizierung</p>

      {/* the OIDC library reports a failed redirect only here, not by throwing
          - without this block, the login button appears dead */}
      {error && (
        <div className="auth-error">
          <h2>{t('auth.errorTitle')}</h2>
          <pre>{error.message}</pre>
        </div>
      )}

      {/* fallback button if auto-login fails */}
      <button onClick={() => login({ state: { returnTo } })}>
        Mit Keycloak anmelden
      </button>
    </div>
  );
};
